import "./App.css";
import { ColorModeProvider } from "./components/ui/color-mode";
import {
    NotFound,
    Privacy,
    AboutUsPage,
    Imprint
} from "./pages";
import { Route, Routes, Navigate } from "react-router-dom";
import { MilestonesPage } from "./pages/Milestones";
import "@fontsource/hanken-grotesk";

function App() {
    return (
        <ColorModeProvider>
            <Routes>
                {/* public routes */}
                <Route path="/milestones" element={<MilestonesPage />} exact />
                <Route path="/" element={<AboutUsPage />} exact />


                {/* legal stuff */}
                <Route path="/privacy" element={<Privacy />} exact />
                {/* <Route path="/terms" element={<Terms />} exact /> */}
                <Route path="/imprint" element={<Imprint />} exact />

                {/* redirect to login if not authenticated */}
                {/* <Route path="/" element={<Navigate to="/login" />} exact /> */}
                <Route path="/about" element={<Navigate to="/" />} exact />

                {/* catch all */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </ColorModeProvider>
    );
}

export default App;
